const API_STATUS = {
  GETTING: 'GETTING',
  UPDATING: 'UPDATING',
  DONE: 'DONE',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
} as const;

export default API_STATUS;
